import { useState, useEffect } from 'react';
import { debounce } from '../utils/lodash-alternatives';

interface SizeState {
  height: number;
  width: number;
  screenHeight: number;
  screenWidth: number;
  offsetHeight: number;
  outerHeight: number;
}

export const useWindowSize = () => {
  const [size, setSize] = useState<SizeState>({
    height: window.innerHeight,
    width: window.innerWidth,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    offsetHeight: document.body.offsetHeight,
    outerHeight: window.outerHeight,
  });

  useEffect(() => {
    // as we need new values after resize, we need to wait while resize is finished
    const handleResize = debounce(() => {
      setSize({
        height: window.innerHeight,
        width: window.innerWidth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        offsetHeight: document.body.offsetHeight,
        outerHeight: window.outerHeight,
      });
    }, 500);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
};
